import { ErrorView } from './ErrorView';
import { type ErrorConfigMap, ErrorType } from './types';

export const UNEXPECTED_ERROR_CODE = 'unexpected-error';
export enum GLOBAL_ERRORS {
  FATAL = 'fatal',
  NOT_FOUND = 'not-found',
  IMPLEMENTATION_DEFECT = 'implementation-defect',
  INTERNAL = 'internal',
  INTERNAL_1 = 'INTERNAL',
  INCOMPLETE_OPERATION = 'incomplete-operation',
  TENANT_NOT_FOUND = 'tenant-not-found',
}

export enum FULL_PAGE_ERRORS {
  SYSTEM_ERROR = 'SYSTEM_ERROR',
  FATAL_ERROR = 'FATAL_ERROR',
}

export const errorConfiguration: ErrorConfigMap = {
  [GLOBAL_ERRORS.NOT_FOUND]: {
    errorCode: GLOBAL_ERRORS.NOT_FOUND,
    type: 'warning',
    errorType: ErrorType.GLOBAL,
  },
  [GLOBAL_ERRORS.IMPLEMENTATION_DEFECT]: {
    errorCode: UNEXPECTED_ERROR_CODE,
    type: 'warning',
    errorType: ErrorType.GLOBAL,
  },
  [GLOBAL_ERRORS.INTERNAL]: {
    errorCode: UNEXPECTED_ERROR_CODE,
    type: 'warning',
    errorType: ErrorType.GLOBAL,
  },
  [GLOBAL_ERRORS.INTERNAL_1]: {
    errorCode: UNEXPECTED_ERROR_CODE,
    type: 'warning',
    errorType: ErrorType.GLOBAL,
  },
  [GLOBAL_ERRORS.INCOMPLETE_OPERATION]: {
    errorCode: UNEXPECTED_ERROR_CODE,
    type: 'warning',
    errorType: ErrorType.GLOBAL,
  },
  [GLOBAL_ERRORS.FATAL]: {
    errorCode: UNEXPECTED_ERROR_CODE,
    type: 'warning',
    errorType: ErrorType.GLOBAL,
  },
  [GLOBAL_ERRORS.TENANT_NOT_FOUND]: {
    errorCode: GLOBAL_ERRORS.TENANT_NOT_FOUND,
    type: 'error',
    errorType: ErrorType.GLOBAL,
  },
  [FULL_PAGE_ERRORS.SYSTEM_ERROR]: {
    errorCode: UNEXPECTED_ERROR_CODE,
    type: 'warning',
    errorType: ErrorType.FULL_PAGE,
    errorView: <ErrorView />,
  },
  [FULL_PAGE_ERRORS.FATAL_ERROR]: {
    errorCode: UNEXPECTED_ERROR_CODE,
    type: 'warning',
    errorType: ErrorType.FULL_PAGE,
    errorView: <ErrorView />,
  },
};
